'use client'

import React from 'react'
import { useLocale, useTranslations } from 'next-intl'
import YouTubeIcon from '@mui/icons-material/YouTube'
import InstagramIcon from '@mui/icons-material/Instagram'
import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'

import { useAppSelector } from '@/src/redux/store'
import { selectAuth } from '@/src/redux/slices/authSlice'
import { HomepageFooter } from './homepageFooter'

const HomepageFooterWrapper: React.FC = () => {
    const locale = useLocale()
    const t = useTranslations('footer')
    const user = useAppSelector(selectAuth)

    // Social media links configuration
    const socialMediaLinks = [
        {
            name: 'youtube',
            href: 'https://www.youtube.com/user/FlyinVideos',
            icon: YouTubeIcon
        },
        {
            name: 'twitter',
            href: 'https://twitter.com/flyincom',
            icon: 'twitter' // Custom SVG
        },
        {
            name: 'instagram',
            href: 'https://www.instagram.com/flyincom/',
            icon: InstagramIcon
        },
        {
            name: 'facebook',
            href: 'https://www.facebook.com/flyin.com',
            icon: FacebookIcon
        },
        {
            name: 'linkedin',
            href: 'https://www.linkedin.com/company/flyin-com',
            icon: LinkedInIcon
        },
        {
            name: 'threads',
            href: 'https://www.threads.net/@flyincom',
            icon: 'threads'
        }
    ]

    // Company links
    const companyLinks = [
        {
            label: t('aboutUs'),
            href: `/aboutUs.${locale}.html`
        },
        {
            label: t('faqs'),
            href: `/faqs.${locale}.html`
        },
        {
            label: t('privacyPolicy'),
            href: `/privacyPolicy.${locale}.html`
        },
        {
            label: t('termsOfUse'),
            href: `/termsOfUse.${locale}.html`
        }
    ]

    // Support links
    const supportLinks = [
        {
            label: t('flyinWallet'),
            href: `/accounts/wallet`
        },
        {
            label: t('contactUs'),
            href: `/contactUs.${locale}.html`
        },
        {
            label: t('addYourProperty'),
            href: `/addProperty.${locale}.html`
        },
        {
            label: t('fileClaim'),
            href: `/howTo.${locale}.html`
        }
    ]

    return (
        <HomepageFooter
            companyLinks={companyLinks}
            supportLinks={supportLinks}
            socialMediaLinks={socialMediaLinks}
            isSignedIn={user.signedIn}
        />
    )
}

export { HomepageFooterWrapper }
export default HomepageFooterWrapper
